import { categorizeTransactionError } from "./categorizeTransactionError";
/**
 * Error on a Solana transaction
 */
export class SolanaTransactionError extends Error {
    constructor(network, originalError, txs) {
        super(originalError.message);
        this.network = network;
        this.originalError = originalError;
        this.txs = txs;
        this.name = "SolanaTransactionError";
        this.stack = originalError.stack;
    }
    /**
     * Tag used for grouping errors together.
     */
    get tag() {
        return categorizeTransactionError(this.message);
    }
    /**
     * Fingerprint used for grouping errors.
     */
    get fingerprint() {
        const tag = this.tag;
        if (tag) {
            return [this.name, tag];
        }
        return [this.name, ...this.message.split(": ")];
    }
}
export class InsufficientSOLError extends Error {
    constructor() {
        super("Insufficient SOL balance");
        this.name = "InsufficientSOLError";
    }
}
//# sourceMappingURL=SolanaTransactionError.js.map